import { SECOND_BAGGAGE } from '@eti/products/dist/products';
import { sortAccordingToArray } from '../../../../common/utils/utils';
import type { AddOnOrdersType, AvailableExtraProductsType } from '../../models';

export const getUpsellProductsPrioritised = (
  availableExtraProducts: AvailableExtraProductsType,
  upsellProductsOrder: string[] = [],
) => {
  // TODO: Currently, the Second Bag is returned in the availableExtraProducts because it is offered through the Mobile App.
  //  The product is filtered out until it is ready to be offered post-booking in Extra Products tab. Remove filtering when this is done.
  const availableExtraProductsWithoutSecondBag = availableExtraProducts.filter(
    (product) => Number(product.id) !== SECOND_BAGGAGE.id,
  );
  if (availableExtraProductsWithoutSecondBag.length === 0) {
    return null;
  }

  const upsellProductsOrderToLowerCase = upsellProductsOrder.map((c: string) => c.toLowerCase());
  const availableExtraProductsSorted: AvailableExtraProductsType = [
    ...availableExtraProductsWithoutSecondBag,
  ].sort(sortAccordingToArray(upsellProductsOrderToLowerCase));
  const primaryUpsellProduct = upsellProductsOrderToLowerCase.includes(
    availableExtraProductsSorted[0].code.toLowerCase(),
  )
    ? availableExtraProductsSorted.shift()
    : null;

  return {
    primaryUpsellProduct,
    secondaryUpsellProducts: availableExtraProductsSorted.slice(0, 3),
  };
};

export const getBaggageGDSInfoPerTraveler = (
  addOnOrders: AddOnOrdersType,
): Record<string, string[]> => {
  return addOnOrders.reduce((acc: Record<string, string[]>, addOnOrder) => {
    if (addOnOrder.extraProducts) {
      addOnOrder.extraProducts.forEach((product) => {
        if (
          product?.id === '235' &&
          product?.buySpecification?.__typename === 'BuySpecificationCartTraveler'
        ) {
          product?.buySpecification?.travelerPrices.forEach((travelerPrice) => {
            const travelerId = travelerPrice?.travelerId;
            const { agentNotes } = product.texts;

            if (travelerId && agentNotes) {
              if (acc[travelerId]) {
                acc[travelerId].push(agentNotes);
              } else {
                acc[travelerId] = [agentNotes];
              }
            }
          });
        }
      });
    }
    return acc;
  }, {});
};
